<script setup lang="ts">
import { computed, inject } from "vue";
import { resultPremiumsKey } from "@/components/keys";

const props = defineProps<{
    premiumId?: number;
}>();

const premiumsContext = inject(resultPremiumsKey);
if (!premiumsContext) {
    throw new Error("Premiums context not provided");
}

const isOpen = computed(() => {
    return premiumsContext.activePremium.value === props.premiumId;
});
</script>

<template>
    <div class="result-summary-container">
        <div class="result-summary-container__first">
            <slot name="first" />
        </div>
        <div class="result-summary-container__second">
            <slot name="second" />
            <div
                v-if="$slots['cta']"
                class="result-cta"
            >
                <slot
                    name="cta"
                    :more-info-open="isOpen"
                    :toggle-more-info="premiumsContext.togglePremium"
                />
            </div>
        </div>
    </div>
    <div
        v-if="$slots['tablet-cta']"
        class="tablet-cta"
    >
        <slot
            name="tablet-cta"
            :more-info-open="isOpen"
            :toggle-more-info="premiumsContext.togglePremium"
        />
    </div>
    <div
        v-if="$slots['desktop-expiry']"
        class="desktop-expiry"
    >
        <slot name="desktop-expiry" />
    </div>
    <div
        v-if="$slots['more-info']"
        :id="'premium-details_' + premiumId"
        class="moreInfo"
        :class="isOpen ? '' : 'collapse'"
        :hidden="!isOpen"
    >
        <slot
            v-if="isOpen"
            name="more-info-banner"
        />
        <div class="more-info-content">
            <slot name="more-info" />
        </div>
    </div>
</template>

<style scoped>
.result-summary-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
}
.result-summary-container__first,
.result-summary-container__second {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
}
.result-summary-container__second {
    border-left: 1px solid #cfd4d9;
}
.tablet-cta {
    display: none;
}
.moreInfo:not(.collapse) {
    padding: 18px;
}
.more-info-content {
    display: flex;
    flex-direction: row;
    gap: 12px;
}

@media (max-width: 1200px) {
    .desktop-expiry {
        display: none;
    }
    .result-cta {
        display: none;
    }
    .tablet-cta {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        margin-top: 8px;
    }
    .result-summary-container__first {
        width: 62%;
    }
    .result-summary-container__second {
        width: 38%;
    }
}
@media (max-width: 768px) {
    .result-summary-container {
        flex-direction: column;
    }
    .result-summary-container__first,
    .result-summary-container__second  {
        width: 100%;
    }
    .result-summary-container__second {
        border-left: none;
        border-top: 1px solid #cfd4d9;
        margin-top: 16px;
        padding-top: 16px;
    }
    .more-info-content {
        flex-direction: column-reverse;
    }
}
</style>
